// extracted by mini-css-extract-plugin
export var cardTitle = "_c8-1";
export var commentBubble = "_c8-e";
export var commentForm = "_c8-a";
export var commentInput = "_c8-b";
export var commentLabel = "_c8-d";
export var commentPrompt = "_c8-9";
export var csatCard = "_c8-0";
export var feedbackSection = "_c8-7";
export var starDisabled = "_c8-6";
export var starEmpty = "_c8-5";
export var starFilled = "_c8-4";
export var starWrapper = "_c8-3";
export var starsContainer = "_c8-2";
export var submittedComment = "_c8-c";
export var thankYouText = "_c8-8";